define([
	"csi/access/_base",
	"csi/access/access",
	"csi/access/full",
	"csi/access/readOnly"
], function(csiAccess, access, full, readOnly) {
	const HIGG_ADMIN_ROLE = ["Higg Material Administrator"];
	csiAccess.addViewRoles({
		"_CS_Data": {
			"HiggMaterialLib": {
				"NewHiggMaterial": access(full(HIGG_ADMIN_ROLE)),
			}
		},
	});
});